export default __webpack_public_path__ + "static/media/E8.eba099e1.jpg";